import React from 'react';
import kebabCase from 'lodash.kebabcase';
import he from 'he';
import { FootNote } from '@massds/mayflower-react';

// eslint-disable-next-line import/prefer-default-export
export const slugify = (string) => {
  const item = string && !Number.isNaN(Number(string)) ? string.toString() : string;
  // replace white space with -, replace & with and, remove special characters '(), replace period,  lowercase string
  return(item && typeof item === 'string' && item.replace(/ |\/|\./g, '-').replace(/&/g, 'and').replace(/['(),]/g, '').toLowerCase());
};

export const fileSlug = (string) => {
  const path = !Number.isNaN(Number(string)) ? kebabCase(string.toString()) : kebabCase(string);
  return(`${path}.csv`);
};

export const getObjByValue = (arr, value, key) => {
  let i = 0;
  const arrayMax = arr.length;
  for (; i < arrayMax; i += 1) {
    const item = arr[i];
    if (item[key] === value) {
      return item;
    }
  }
  return undefined;
};

export const getTextByValue = (array = [], value) => {
  const matchedItem = getObjByValue(array, value, 'key');
  return matchedItem ? matchedItem.text : '';
};

export const getNameByValue = (array = [], value) => {
  const matchedItem = getObjByValue(array, value, 'value');
  return matchedItem ? matchedItem.name : '';
};

/** Get the matching object's index in an array
  * @param {boolean} arr - the array
  * @param {*} value - matching value
  * @param {string} key - object key for the matching value
  * @param {boolean} slug - the match is through slugifying (only apply to string value)
  * @returns {number} index - the index of the matching object in the array
  */
export const findObjIndexByKey = ({ arr, value, key, slug = false }) => {
  const index = Array.isArray(arr) && arr.findIndex(object => {
    const condition = (slug && typeof(value) === 'string') ? slugify(object[key]) === slugify(value) : object[key] === value;
    return condition;
  });
  return index;
}

export const getFootnotes = (footnotes) => {
  const FootNotes = footnotes.map((footnote) => (
    <FootNote index={footnote.index} key={`footnote.${footnote.index}`}>{footnote.text}</FootNote>
  ));
  return(FootNotes);
};

/**
 * Searches an object to see if a dot notation path string exists.
 * @param {object} obj - The object to search.
 * @param {string} path - A dot notation path that should exist within the object's properties.
 * @returns {boolean} True if the path can be found within the object's properties, otherwise false.
 */
export const dotHas = (obj, path) => {
  const properties = path.split('.');
  let searchObj = obj;
  let i = 0;
  const maxProps = properties.length;
  for (; i < maxProps; i += 1) {
    if (!Object.prototype.hasOwnProperty.call(searchObj, properties[i])) {
      return false;
    }
    if (typeof searchObj[properties[i]] === 'object') {
      searchObj = searchObj[properties[i]];
    }
  }
  return true;
};

/**
 * Convert a string to Title Case
 * @param {string} str - The string that needs to be converted
 */
export const toTitleCase = (str) => {
  let i = 0;
  const string = str.toLowerCase().split(' ');
  for (; i < string.length; i += 1) {
    string[i] = string[i].charAt(0).toUpperCase() + string[i].slice(1);
  }
  return string.join(' ');
};

/**
 * Strip an html string to get the content
 * @param {string} str - The HTML string that needs to be stripped
 */
export const stripHTML = (htmlString) => {
  const strippedString = (htmlString || '').replace(/<[^>]+>/g, '');
  return he.decode(strippedString);
};
